import '@web/shared-digital-library/icons/svg-originals/bx-chevron-right.svg';
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
var CardHorizontal = () => import('~/components/molecules/CardHorizontal.vue');
export default {
  name: 'NavItemLeaf',
  components: {
    MdmLink,
    CardHorizontal
  },
  props: {
    level: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    withColor: {
      type: Boolean,
      default: false
    },
    withArrow: {
      type: Boolean,
      default: false
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  }
};